class CartDrawerUpdater {
  constructor() {
    this.bindEvents();
    // Cart drawer açıldığında initialize et
    document.addEventListener('cart:open', () => this.initializeCartDrawer());
    // Sayfa yüklendiğinde initialize et
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeCartDrawer());
    } else {
      this.initializeCartDrawer();
    }
  }

  initializeCartDrawer() {
    // Cart drawer'ı bul
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Cart drawer açıksa ve daha önce initialize edilmediyse
    if (!cartDrawer.hasAttribute('data-initialized')) {
      this.refreshCart();
      cartDrawer.setAttribute('data-initialized', 'true');
    }
  }

  bindEvents() {
    // Quantity butonları için event listener
    document.addEventListener('click', this.handleQuantityButtonClick.bind(this));

    // Cart update event'leri için listener'lar
    document.addEventListener('cart:add', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:update', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:change', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:refresh', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));

    // Add to cart butonları için event listener
    document.addEventListener('click', this.handleAddToCartClick.bind(this));

    // Silme butonları için event listener
    document.addEventListener('click', this.handleRemoveButtonClick.bind(this));
  }

  async handleRemoveButtonClick(event) {
    const removeButton = event.target.closest('.cart-item__remove-button');
    if (!removeButton) return;

    event.preventDefault();
    event.stopPropagation();

    const itemKey = removeButton.getAttribute('data-cart-item-key');
    const cartItem = removeButton.closest('.cart-item');

    if (!itemKey || !cartItem) return;

    removeButton.disabled = true;
    cartItem.style.opacity = '0.5';
    cartItem.style.pointerEvents = 'none';

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });

      if (!response.ok) throw new Error('Cart update failed');

      // Animate out and remove item
      cartItem.style.height = cartItem.offsetHeight + 'px';
      cartItem.style.transition = 'all 0.3s ease-out';
      requestAnimationFrame(() => {
        cartItem.style.height = '0';
        cartItem.style.opacity = '0';
        cartItem.style.margin = '0';
        cartItem.style.padding = '0';
      });

      setTimeout(() => {
        cartItem.remove();
        this.refreshCart();
      }, 300);

    } catch {
      removeButton.disabled = false;
      cartItem.style.opacity = '1';
      cartItem.style.pointerEvents = 'auto';
    }
  }

  async handleQuantityButtonClick(event) {
    const button = event.target.closest('.quantity-button');
    if (!button) return;

    const container = button.closest('.cart-item-quantity');
    if (!container) return;

    const itemKey = container.dataset.itemKey;
    const quantityText = container.querySelector('.quantity-text');
    const currentQuantity = parseInt(quantityText.textContent);
    const isPlus = button.classList.contains('plus');
    const newQuantity = isPlus ? currentQuantity + 1 : Math.max(1, currentQuantity - 1);

    const cartItem = container.closest('.cart-item');
    if (cartItem) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }

    try {
      await this.updateCart(itemKey, newQuantity);
    } catch (error) {
      console.error('Cart update error:', error);
      quantityText.textContent = currentQuantity;
    } finally {
      if (cartItem) {
        cartItem.style.opacity = '1';
        cartItem.style.pointerEvents = 'auto';
      }
    }
  }

  async handleAddToCartClick(event) {
    const addButton = event.target.closest('.add-to-cart-button');
    if (!addButton) return;

    // Add to cart işlemi tamamlandıktan sonra cart'ı güncelle
    setTimeout(async () => {
      await this.refreshCart();
    }, 500);
  }

  async handleCartUpdate(event) {
    await this.refreshCart();
  }

  async updateCart(itemKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    });

    if (!response.ok) throw new Error('Cart update failed');
    
    await this.refreshCart();
  }

  async refreshCart() {
    try {
      // Get current cart state
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // Get fresh cart HTML
      const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
      const sectionsData = await sectionsResponse.json();

      if (sectionsData['cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionsData['cart-drawer'];

        // Cart drawer elementini bul
        const cartDrawer = document.querySelector('cart-drawer');
        const newCartDrawer = tempDiv.querySelector('cart-drawer');
        
        if (cartDrawer && newCartDrawer) {
          // is-empty class'ını kontrol et
          if (newCartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
            // Boş cart içeriğini güncelle
            const newInnerEmpty = tempDiv.querySelector('.drawer__inner-empty');
            const currentInner = cartDrawer.querySelector('.drawer__inner');
            if (newInnerEmpty && currentInner) {
              currentInner.innerHTML = newInnerEmpty.innerHTML;
            }
          } else {
            cartDrawer.classList.remove('is-empty');
            // Normal cart içeriğini güncelle
            const newCartItems = tempDiv.querySelector('#CartDrawer-CartItems');
            const currentCartItems = document.querySelector('#CartDrawer-CartItems');
            if (newCartItems && currentCartItems) {
              currentCartItems.innerHTML = newCartItems.innerHTML;
            }

            // Update cart header
            const newHeader = tempDiv.querySelector('.drawer__header');
            const currentHeader = document.querySelector('.drawer__header');
            if (newHeader && currentHeader) {
              currentHeader.innerHTML = newHeader.innerHTML;
            }

            // Update cart totals
            const newTotals = tempDiv.querySelector('.cart-drawer__totals');
            const currentTotals = document.querySelector('.cart-drawer__totals');
            if (newTotals && currentTotals) {
              currentTotals.innerHTML = newTotals.innerHTML;
            }

            // Update checkpoints bar
            const newCheckpointsBar = tempDiv.querySelector('.cart-progress');
            const currentCheckpointsBar = document.querySelector('.cart-progress');
            if (newCheckpointsBar && currentCheckpointsBar) {
              currentCheckpointsBar.innerHTML = newCheckpointsBar.innerHTML;
            }
          }
        }
      }

      // Update cart bubble
      if (sectionsData['cart-icon-bubble']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionsData['cart-icon-bubble'];
        
        document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
          const newBubble = tempDiv.querySelector('.cart-count-bubble');
          if (newBubble) {
            bubble.innerHTML = newBubble.innerHTML;
          } else {
            bubble.style.display = 'none';
          }
        });
      }



    } catch (error) {
      console.error('Cart refresh error:', error);
    }
  }
}

// Initialize cart updater
new CartDrawerUpdater();